import { Chart, Grid } from 'components'
import { StatTile } from '..'
import { useAggregations } from '../../utils/analyticsUtils'
import { useWorkspaceSmartColumns } from '../../utils/lookupUtils'
import { useWorkspaceAnalytics } from './WorkspaceAnalyticsProvider'

export default function WorkspaceAnalyticsSmartColumnsSection() {
  const { dateRange } = useWorkspaceAnalytics()
  const smartColumnsWithCharts = useWorkspaceSmartColumns(undefined, true)
  const { aggregations } = useAggregations(
    smartColumnsWithCharts.map(smartCol => ({
      table: 'smartProperties',
      values: ['_count'],
      categories: ['text'],
      filters: [
        { field: 'name', operator: 'eq', value: smartCol, table: 'smartProperties' },
        { field: 'text', operator: 'isNull', value: false, table: 'smartProperties' },
      ],
      sort: { _count: 'DESC' },
      limit: 10,
    })),
    { dateRange }
  )

  const columnsWithAggregations = smartColumnsWithCharts
    .map((label, i) => {
      const aggregation = aggregations[i]
      const count = Number(aggregations[i].data?.[0]._count) ?? 0
      return { label, count, aggregation }
    })
    .filter(c => c.count)

  if (!columnsWithAggregations.length) return null

  return (
    <Grid templateColumns={['1fr', null, 'repeat(2, 1fr)']} gap={6}>
      {columnsWithAggregations.map(({ label, count, aggregation }) => (
        <StatTile key={label} alignItems="stretch" height="350px" label={label} num={count} canCopy>
          <Chart {...aggregation} orientation={count <= 5 ? 'column' : 'bar'} />
        </StatTile>
      ))}
    </Grid>
  )
}
